let BackUrl = null;
let BasiUrl = process.env.VUE_APP_BASIC_API;
// if (BasiUrl === "dev") {
// BackUrl = "https://www.mtu.plus";
// BackUrl = "https://ils.wakeychan.com";
// } else if (BasiUrl === "prd") {
//   BackUrl = "prd url";
// }
export default {
  // BackUrl,
  BasiUrl,
  baseUrl: "",
  baseRealm: "",
  imgprev: ""
};
// export default {
//   // BackUrl,
//   BasiUrl,
//   baseUrl: "https://www.mtu.plus",
//   baseRealm: "www.mtu.plus",
//   imgprev: "https://www.mtu.plus/local/miniprogram/images/"
// };
// export default {
//   BackUrl,
//   BasiUrl,
//   baseUrl: "https://ils.wakeychan.com",
//   baseRealm: "ils.wakeychan.com",
//   imgprev: "https://ils.wakeychan.com/local/miniprogram/images/"
// };
